/* globals Skills */

import { createRef } from 'react'

const HRStars = class extends React.Component {
  constructor(props) {
    super()
    this.state = {
      currentLevel: props.hr_stars === null ? -1 : props.hr_stars
    }

    this.inputContainerRef = createRef(null)
  }

  componentDidMount () {
    const inputContainer = this.inputContainerRef.current.inputContainer
    if (inputContainer) {
      Skills.initHelpPopover($(inputContainer.firstChild))
    }
  }

  render () {
    const stars = [4, 3, 2, 1] // inverted array for css hover trick
    const author = []
    if (this.props.author) author.push(this.props.author)
    if (this.props.date) author.push(this.props.date)
    if (this.props.readOnly) {
      if (this.props.input_type === 'boolean') {
        // Read only boolean
        return (
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars no-actions'>
              <i className='fa fa-check green' />
            </div>
          </div>
        )
      } else {
        return (
          // Read only stars
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars no-actions'>
              {stars.map((value) => (
                <div
                  key={this.props.skill_id + '-' + value}
                  className={value <= this.state.currentLevel ? 'star active' : 'star'}
                />))}
            </div>
          </div>
        )
      }
    } else {
      if (this.props.input_type === 'boolean') {
        // Editable boolean
        return (
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars text-center'>
              <label className='switchery small-switchery'>
                <input
                  type='checkbox'
                  checked={this.state.currentLevel === 4}
                  onChange={this._checkStar.bind(this, 4)}
                />
                <span className='box' />
              </label>
              <input
                type='hidden' id={`selected_${this.props.skill_id}`}
                name={`selected[${this.props.skill_id}]`}
                defaultValue={this.state.currentLevel || -1}
              />
            </div>
          </div>
        )
      } else {
        // Editable stars
        return (
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars'>
              {stars.map((value) => {
                return (
                  <a
                    key={this.props.skill_id + '-' + value}
                    onClick={this._checkStar.bind(this, value)}
                    className={value <= this.state.currentLevel ? 'star active' : 'star'}
                  />
                )
              })}
            </div>
            <input
              type='hidden' id={`selected_${this.props.skill_id}`}
              name={`selected[${this.props.skill_id}]`}
              value={this.state.currentLevel || -1}
            />
          </div>
        )
      }
    }
  }

  _checkStar (value) {
    const form = $(this.inputContainerRef.current).parents('form')
    this.setState({ currentLevel: value === this.state.currentLevel ? 0 : value })
    $('button[type="submit"]', form).prop('disabled', false)
  }
}

const PortalHRStars = class extends React.Component {
  constructor(props) {
    super()
    this.state = {
      currentLevel: props.candidate_stars || 0
    }
  }

  componentDidMount () {
    // Skills.initHelpPopover($(this.refs.inputContainer));
  }

  render () {
    const stars = [4, 3, 2, 1] // inverted array for css hover trick
    const author = []
    if (this.props.author) author.push(this.props.author)
    if (this.props.date) author.push(this.props.date)
    if (this.props.readOnly) {
      if (this.props.input_type === 'boolean') {
        // Read only boolean
        return (
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars no-actions'>
              <i className='fa fa-check green' />
            </div>
          </div>
        )
      } else {
        return (
          // Read only stars
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars no-actions'>
              {stars.map((value) => (
                <div
                  key={this.props.skill_id + '-' + value}
                  className={value <= this.state.currentLevel ? 'star active' : 'star'}
                />))}
            </div>
          </div>
        )
      }
    } else {
      if (this.props.input_type === 'boolean') {
        // Editable boolean
        return (
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars text-center'>
              <label className='switchery small-switchery'>
                <input
                  type='checkbox'
                  checked={this.state.currentLevel === 4}
                  onChange={this._checkStar.bind(this, 4)}
                />
                <span className='box' />
              </label>
              <input type='hidden' value={this.props.skill_id} name={`candidate[skills_attributes][${this.props.skill_id}][skill_id]`} />
              <input type='hidden' value={this.state.currentLevel || 0} name={`candidate[skills_attributes][${this.props.skill_id}][level]`} />
              <input type='hidden' value={this.props.month} name={`candidate[skills_attributes][${this.props.skill_id}][month]`} />
              {this.props.id && <input type='hidden' value={this.props.id} name={`candidate[skills_attributes][${this.props.skill_id}][id]`} />}
            </div>
          </div>
        )
      } else {
        return (
          // Editable stars
          <div className='skill-hr' title={author.join(', ')} ref={this.inputContainerRef}>
            <div className='hr-stars'>
              {stars.map((value) => {
                return (
                  <a
                    key={this.props.skill_id + '-' + value}
                    onClick={this._checkStar.bind(this, value)}
                    className={value <= this.state.currentLevel ? 'star active' : 'star'}
                  />
                )
              })}
            </div>
            <input type='hidden' value={this.props.skill_id} name={`candidate[skills_attributes][${this.props.skill_id}][skill_id]`} />
            <input type='hidden' value={this.state.currentLevel || 0} name={`candidate[skills_attributes][${this.props.skill_id}][level]`} />
            <input type='hidden' value={this.props.month} name={`candidate[skills_attributes][${this.props.skill_id}][month]`} />
            {this.props.id && <input type='hidden' value={this.props.id} name={`candidate[skills_attributes][${this.props.skill_id}][id]`} />}
          </div>
        )
      }
    }
  }

  _checkStar (value) {
    this.setState({ currentLevel: value === this.state.currentLevel ? 0 : value })
  }
}

export default gon.application.portal ? PortalHRStars : HRStars
